import api from './api';
import { Ubicacion } from '../types';

const API_URL = "/ubicaciones";

export const getUbicaciones = async () => {
    const response = await api.get<{ message: string, data: Ubicacion[] }>(API_URL);
    return response.data.data;
};

export const createUbicacion = async (data: Partial<Ubicacion>) => {
    const response = await api.post(API_URL, data);
    return response.data;
};

export const updateUbicacion = async (id: number, data: Partial<Ubicacion>) => {
    const response = await api.put(`${API_URL}/${id}`, data);
    return response.data;
};

export const deleteUbicacion = async (id: number) => {
    const response = await api.delete(`${API_URL}/${id}`);
    return response.data;
};

